import { Component, EventEmitter, Output } from '@angular/core';
import { AnimationService } from '../../element-editor/animation/animation.service';
import { ShapeService } from '../../element-editor/shape/shape.service';

@Component({
  selector: 'nw-video-controls',
  templateUrl: './video-controls.component.html',
  styleUrls: ['./video-controls.component.scss'],
})
export class VideoControlsComponent {
  get currentTime() {
    return this.animationService.currentAnimationTime;
    // return this.timeLine.time();
  }
  get duration() {
    return this.animationService.totalAnimationDuration;
  }
  get playing() {
    return this.animationService.animationState == 'started';
  }
  @Output() playToggle = new EventEmitter<void>();
  @Output() seek = new EventEmitter<number>(); // 0..1 fraction

  get progressPct(): number {
    if (!this.duration || this.duration <= 0) return 0;
    const pct = (this.currentTime / this.duration) * 100;
    return Math.max(0, Math.min(100, pct));
  }

  constructor(
    private readonly animationService: AnimationService,
    private readonly shapeService: ShapeService,
  ) {}

  rewind() {
    // -- // -- //
    this.pause();
    this.shapeService.resetToStart();
  }

  forward() {
    this.shapeService.goToLast();
  }

  play() {
    this.animationService.gsapAnimate();
  }

  pause() {
    this.animationService.pauseGsapAnimate();
  }
  formatTime(totalSeconds: number): string {
    if (!isFinite(totalSeconds) || totalSeconds < 0) totalSeconds = 0;
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = Math.floor(totalSeconds % 60);
    const mm = hours > 0 ? String(minutes).padStart(2, '0') : String(minutes);
    const ss = String(seconds).padStart(2, '0');
    return hours > 0 ? `${hours}:${mm}:${ss}` : `${mm}:${ss}`;
  }

  onProgressClick(evt: MouseEvent) {
    const target = evt.currentTarget as HTMLElement | null;
    if (!target) return;
    const rect = target.getBoundingClientRect();
    const x = evt.clientX - rect.left;
    const fraction = Math.max(0, Math.min(1, x / rect.width));
    this.seek.emit(fraction);
  }
}
